<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>فعالیت‌ها</v-card-title>
      <v-card-text>
        <v-row v-if="isAdmin">
          <v-col cols="4">
            <v-select
                v-model="userTypeFilter"
                :items="[
                  { text: 'همه', value: 'all' },
                  { text: 'ادمین', value: 'admin' },
                  { text: 'مربی', value: 'instructor' },
                  { text: 'هنرجو', value: 'student' },
                ]"
                label="فیلتر نوع کاربر"
                color="black"
                @change="getEntities"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="searchQuery"
                label="جستجو بر اساس نام، موبایل یا آی‌دی"
                color="black"
                clearable
                @keyup.enter="getEntities"
            />
          </v-col>
          <v-col cols="4" class="text-left">
            <v-btn color="primary" style="letter-spacing: normal;" @click="getEntities">بروزرسانی</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="8">
            <v-text-field
                v-model="searchQuery"
                label="جستجو بر اساس نام، موبایل یا آی‌دی"
                color="black"
                clearable
                @keyup.enter="getEntities"
            />
          </v-col>
          <v-col cols="4" class="text-left">
            <v-btn color="primary" style="letter-spacing: normal;" @click="getEntities">بروزرسانی</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="mb-4" v-if="logs.data && logs.data.length">
              <strong>آخرین فعالیت:</strong> {{ logs.data[0].title_fa }}
            </div>
            <v-data-table
                :headers="headers"
                :items="logs.data"
                :loading="loading"
                :options.sync="options"
                :items-per-page="logs.per_page"
                :server-items-length="logs.total"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                dense
                item-value="id"
            >
              <template v-slot:[`item.user_type`]="{ item }">
                <v-chip x-small color="primary" text-color="white" v-if="item.user_type === 'admin'">ادمین</v-chip>
                <v-chip x-small color="secondary" text-color="white" v-else-if="item.user_type === 'instructor'">مربی</v-chip>
                <v-chip x-small color="success" text-color="white" v-else>هنرجو</v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ActivityIndex',
  watch: {
    options: {
      handler() {
        this.getEntities()
      },
      deep: true,
    },
  },
  data() {
    return {
      loading: true,
      options: {},
      logs: {
        current_page: 1,
        data: []
      },
      userTypeFilter: 'all',
      isAdmin: this.$cookies.get('userType') === 'admin',
      headers: [
        { text: 'شناسه', value: 'id', align: 'center' },
        { text: 'زمان', value: 'created_at_fa', align: 'center' },
        { text: 'نوع کاربر', value: 'user_type', align: 'center' },
        { text: 'نام کاربر', value: 'user_name', align: 'center' },
        { text: 'موبایل', value: 'user_mobile', align: 'center' },
        { text: 'آخرین فعالیت', value: 'title_fa', align: 'center' },
        { text: 'صفحه', value: 'route_path', align: 'center' },
      ],
      searchQuery: '',
    }
  },
  mounted() {
    this.getEntities()
  },
  methods: {
    getEntities() {
      const endpoint = this.isAdmin ? 'admin/activity/index' : 'instructor/activity/index'
      const params = this.isAdmin ? { user_type: this.userTypeFilter, query: this.searchQuery, ...this.options } : { query: this.searchQuery, ...this.options }
      const url = window.urlBuilder(this.logs, endpoint, params, this.headers)
      window.axios.get(url).then((res) => {
        this.logs = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>
